export { default as InvoiceItemsViewTableFooter } from './InvoiceItemsViewTableFooter';
